export const bio = "I'm Brian Baldner, a Computer Science and Data Science student at the University of Oregon. I've build software and data systems that turn baseball data into tools coaches, players, and analysts can use. I lead development of QuackTrax for Oregon Baseball and worked as a Baseball Systems Associate with the Milwaukee Brewers in summer 2026. My work spans data pipelines, full-stack applications, machine learning, and interactive visualizations.";

export const experience = [
    {
        organization: 'Milwaukee Brewers',
        role: 'Baseball Systems Associate',
        dates: 'June 2026 - September 2026',
        location: 'Milwaukee, Wisconsin',
        highlights: [
            'Automated free-agent eligibility classification in a production contract ingestion pipeline with SQL and regex, eliminating manual R&D spreadsheet tracking.',
            'Developed an ELT pipeline using Apache Airflow, AWS S3, Python, and Snowflake SQL to clean vendor CSVs and reconcile player records for R&D analysis.',
            'Built a full-stack scouting dashboard with Angular, C#, and SQL, including interactive heatmaps, position-specific analytics, and spatial filtering.',
            'Created a Plotly.js animation synchronizing player and ball tracking data to visualize defensive range and routes.',
            'Reviewed pull requests, collaborated with senior engineers, and presented project results to stakeholders.',
        ],
    },
    {
        organization: 'Oregon Baseball',
        role: 'Data Analyst / Software Developer',
        dates: 'May 2025 - Present',
        location: 'Eugene, Oregon',
        highlights: [
            'Lead development of QuackTrax alongside three student developers: a Dash/Flask platform serving 50+ coaches, players, and staff with role-based access and 30+ analytics pages. The platform uses MySQL and Docker on Google Cloud Run.',
            'Design and operate SFTP, REST API, and JSON ingestion pipelines with fuzzy record matching and automated model scoring. Linux cron and GitHub Actions jobs ingest games within an hour and refresh daily leaderboards across 8.2M+ pitches.',
            'Shipped a catch probability system combining SQL feature engineering, an XGBoost classifier, and nightly scoring to power a defensive performance leaderboard with linked video examples.',
            'Reverse engineered a closed-source video system, linked pitch records to clips with fuzzy matching, and migrated tens of thousands of videos to Google Cloud Storage.',
            'Built a Gaussian-smoothed visualization engine for 18+ Plotly heatmaps and work directly with coaches and players to define requirements and support use during practices and games.',
        ],
    },
    {
        organization: 'University of Oregon Computer Science Department',
        role: 'CS 210 Learning Assistant',
        dates: 'September 2025 - December 2025',
        location: 'Eugene, Oregon',
        highlights: ['Assisted students with object-oriented programming in Java, C++, and Python, as well as debugging techniques.'],
    },
];

export const education = {
    school: 'University of Oregon',
    degree: 'Bachelor of Science in Computer Science and Data Science',
    dates: 'September 2024 - Present',
    location: 'Eugene, Oregon',
    gpa: '4.06',
    honors: "Dean's List: Fall 2024, Winter 2025, Spring 2025, Fall 2025, Winter 2026, Spring 2026",
};

export const skills = [
    { category: 'Languages', items: 'Python, SQL, JavaScript, C#, Java, C++, R, HTML/CSS' },
    { category: 'Frameworks and Data', items: 'Angular, React, Flask, Dash, Plotly.js, XGBoost, Apache Airflow, Snowflake, MySQL' },
    { category: 'Cloud and Tools', items: 'AWS S3, Google Cloud, Docker, Git, GitHub Actions, Linux cron' },
];

export const projects = [
    {
        name: 'MacroCam',
        date: 'January 2025',
        technologies: 'JavaScript, React, Expo, App Store Connect, Python, Google Cloud Datastore, Google Cloud App Engine',
        description: 'Built a prototype in 24 hours as the solo developer on a three-person team at QuackHacks 2025. Created a scalable backend with Python, Google Cloud Datastore, and Google Cloud App Engine, then presented the app and received feedback through the Oregon Innovation Challenge.',
    },
    {
        name: 'VolleyStat',
        date: 'September 2023',
        image: 'volleystat',
        description: 'Drawing on my experience playing volleyball, I built a stat-tracking app with React Native and Expo to replace paper stats. I designed it so a coach or parent familiar with volleyball could start tracking with very little instruction.',
    },
    {
        name: 'brianbaldner.com',
        date: 'February 2023',
        image: 'portfolio',
        description: 'I wanted my portfolio to feel personal, so I learned Three.js and built a 3D room featuring my photography, a clock, and a laptop. The laptop runs this Windows-inspired desktop, built in React, where visitors can explore my work.',
    },
    {
        name: 'MultiversusTracker.com',
        date: 'July 2022',
        image: 'mvs',
        description: 'Built a player-statistics site with React and a C# backend and documented the game API. The tracker reached 37,000 unique visitors in its first 60 days.',
    },
    {
        name: 'Ultimate Games',
        date: 'December 2018',
        image: 'ultimateGames',
        description: 'My first programming project was an HTML and CSS website collecting browser games for my friends. Seeing people use something I built inspired me to keep learning and start making games of my own.',
    },
];

export const leadership = {
    organization: 'LeetCode Club',
    role: 'Executive Board',
    dates: 'October 2024 - May 2025',
    location: 'University of Oregon',
    description: 'Planned and ran club meetings that taught computer science topics and connected them to LeetCode problems.',
};

export const interests = 'Health and exercise, golf, baseball, video games, and hiking.';
